// Backend-coupled features (tenant sign-in + downloads) are shown only when a
// backend is actually wired. Docs, FAQ, and search are fully static and never
// need a backend.
//
// Default: ON in dev, OFF in production builds — so the public static deploy
// (support.survantic.com) never surfaces a sign-in or downloads page it can't
// serve. Override explicitly at build/run time with VITE_BACKEND_ENABLED=true|false.
const flag = import.meta.env.VITE_BACKEND_ENABLED;

export const BACKEND_ENABLED =
  flag === "true" ? true : flag === "false" ? false : import.meta.env.DEV;
